const DIACRITICS_REGEX = /[\u0300-\u036f]/g;
const VIETNAMESE_D_CHAR_REGEX = /đ/g;
const VIETNAMESE_D_UPPER_CHAR_REGEX = /Đ/g;

export const normalizeText = (value: string): string => {
	return value
		.normalize('NFD')
		.replace(DIACRITICS_REGEX, '')
		.replace(VIETNAMESE_D_CHAR_REGEX, 'd')
		.replace(VIETNAMESE_D_UPPER_CHAR_REGEX, 'D')
		.toLowerCase()
		.trim();
};
